/**
 * 売上一覧 伝票出力
 */
import Vue from 'vue'
import * as httpConst from '../../../../../constants/httpConst'

const API_PATH = `${httpConst.DRIVER_ENDPOINT}/sales/deals/outputs`

const sales_deal_output = {
    namespaced: true,
    actions: {
      update ({ commit }, { id, params }) {
        return new Promise( ( resolve ) => {
          const api_path = `${API_PATH}/${id}`
          Vue.$http.put(api_path, params).then( data => {
            let content = data.content
            resolve(content)
          } )
        })
      },
    }
  }
  export default sales_deal_output
  
